import React, { useState } from "react";
import Swal from "sweetalert2";
import "./modal.css";

const ModalForm = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    msg: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://topfaculty.co.in/api/web_lead.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();
      console.log("API Response:", result);

      if (result.status === "success") {
        Swal.fire({
          title: "Success!",
          text: result.message,
          icon: "success",
          customClass: {
            popup: "swal-custom-popup",
          },
        }).then(() => {
          setFormData({ name: "", phone: "", email: "", msg: "" });
          onClose(); // ✅ close modal after alert
        });
      } else {
        Swal.fire("Error!", result.message, "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      Swal.fire("Error!", "Network error or invalid response", "error");
    }
  };

  if (!show) return null;

  return (
    <div className="google-modal-overlay">
      <div className="google-modal-form ">
        <div className="google-modal-banner">
          <img src="assetsfront/images/modal.png" alt="Modal Banner" />
        </div>

        <button className="google-close-btn" onClick={onClose}>
          ×
        </button>

        <div className="google-modal-header">
          {/* <h2 className="google-modal-title">
            Join our Doubt-Clearing & Live Interactive Sessions!
          </h2> */}
          <p className="google-modal-sub">
             Join our Doubt-Clearing & Live Interactive Sessions!
            Get real-time support, ask questions, and strengthen your
            understanding with expert guidance.
          </p>
        </div>

        <form className="google-form-body" onSubmit={handleSubmit}>
            <div className="row">
          <div className="google-form-group col-lg-6">
            <label>
              Full Name <span className="required">*</span>
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              type="text"
              placeholder="Name"
              required
            />
          </div>

          <div className="google-form-group  col-lg-6">
            
            <label>
              Phone Number <span className="required">*</span>
            </label>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              type="tel"
              placeholder="Phone Number"
              required
            />
          </div></div>

          <div className="google-form-group">
             <label>
              Email Address <span className="required">*</span>
            </label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="email"
              placeholder="E-Mail"
              required
            />
          </div>

          <div className="google-form-group">
            <label>Your Query</label>
            <input
              name="msg"
              value={formData.msg}
              onChange={handleChange}
              type="text"
              placeholder="Type any query..."
            />
          </div>

          <button type="submit" className="google-submit-btn">
            Get It Now
          </button>
        </form>
      </div>
    </div>
  );
};

export default ModalForm;
